import { message } from 'antd'
import React from 'react'
import fetchAPI from '../../../../../lib/utils/fetch-api'

/**
 * Редактирование маршрутов в списке
 */
interface IEditedRow {
  id: React.Key
  [key: string]: any
}
interface IHandleSaveEditParams {
  setLoading: (val: boolean) => void
  getData: () => void
  setSelectedRowKeys: (val: React.Key[]) => void
}

export function handleSaveEdit({ setLoading, getData, setSelectedRowKeys }: IHandleSaveEditParams) {
  return async (editedRows: IEditedRow[]) => {
    try {
      setLoading(true)
      await fetchAPI('/api/logistics/route-sheets/update-group', {
        method: 'POST',
        body: JSON.stringify(editedRows),
        headers: {
          'Content-Type': 'application/json',
        },
      })

      message.success('Данные успешно обновлены')

      getData()
      setSelectedRowKeys([])
    } catch (error) {
      console.error('Error updating deliveries:', error)
      message.error('Ошибка при обновлении данных')
    } finally {
      setLoading(false)
    }
  }
}
